import { ReviewDecisionActions, ReviewOutcomeSummary } from '@/components/common/ReviewDecision';
import { PENDING_REVIEW_STATUS } from '@/constants/reviewStatus';
import { TEACHER_INACTIVATION_REVIEW_SUBJECT } from '../constants/teacherInactivation.constants';
import { useReviewTeacherInactivation } from '../hooks/useReviewTeacherInactivation';
import type { TeacherInactivationRequest } from '../types/teacherInactivation.types';

const TEACHER_INACTIVATION_APPROVAL_WARNING = 'Approving makes this teacher inactive.';

interface TeacherInactivationReviewPanelProps {
  request: TeacherInactivationRequest;
}

export function TeacherInactivationReviewPanel({ request }: TeacherInactivationReviewPanelProps) {
  const reviewMutation = useReviewTeacherInactivation();

  if (request.status === PENDING_REVIEW_STATUS) {
    return (
      <ReviewDecisionActions
        isPending={reviewMutation.isPending}
        approveWarning={TEACHER_INACTIVATION_APPROVAL_WARNING}
        onSubmit={(decision, payload, onDone) =>
          reviewMutation.mutate({ id: request.id, decision, payload }, { onSuccess: onDone })
        }
      />
    );
  }

  return (
    <ReviewOutcomeSummary
      subject={TEACHER_INACTIVATION_REVIEW_SUBJECT}
      status={request.status}
      reviewedByName={request.reviewerName}
      reviewedAt={request.reviewedAt}
      reviewerComment={request.reviewerComment}
    />
  );
}
